import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel, PagingResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import {Observable} from 'rxjs';

export interface ProfessionalStudySchemeReport {
  employee_code: string;
  employee_name: string;
  company_name: string;
  branch_name: string;
  claim_id: string;
  receipt_txn_date: Date;
  date_submission: Date;
  date_final_approval: string;
  validity_start_date: Date;
  validity_end_date: Date;
  professional_body_name: string;
  ccy_code: string;
  claim_amount: number;
  remarks: string;
  status: string;
}


@Injectable({
  providedIn: 'root'
})
export class ClaimProfessionalStudySchemeReportService extends BaseApiTemplateService<ProfessionalStudySchemeReport> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'reports/professional-study-schemes/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'reports/professional-study-schemes/backoffice-ep';

    this.httpClient = http;
  }

  generateReport(body: any, visa: ApiVisa): Observable<PagingResponseModel<ProfessionalStudySchemeReport>> {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'reports/professional-study-schemes/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'reports/professional-study-schemes/backoffice-ep';
    }

    return this.httpClient.post<PagingResponseModel<ProfessionalStudySchemeReport>>(url, body, this.getHttpHeader(visa));
  }

}
